import { reactive } from "vue";
const storageKey = "office.audience";
function stored() {
  try { return JSON.parse(localStorage.getItem(storageKey) || "{}"); } catch { return {}; }
}
const initial = stored();
export const audience = reactive({
  country_code: /^[A-Z]{2}$/.test(initial.country_code || "") ? initial.country_code : "",
  language_code: /^[a-z]{2,3}$/.test(initial.language_code || "") ? initial.language_code : "",
});
export const audienceRoutes = ["/waitings"];
const audienceEndpoints = ["waiting/index"];
export function supportsAudienceEndpoint(url) {
  const endpoint = url.split("/api/v1/")[1]?.split("?")[0];
  return audienceEndpoints.includes(endpoint);
}
export function audienceParams() {
  return Object.fromEntries(Object.entries(audience).filter(([, value]) => value));
}
export function persistAudience() {
  try { localStorage.setItem(storageKey, JSON.stringify(audience)); } catch { /* Session-only fallback. */ }
}
